module.exports = __webpack_public_path__ + "static/media/17_5.9e757b4c.png";